





































































import Vue from 'vue'
import Timer from '@/components/workflow/Timer.tsx'
import Process from '@/components/workflow/Process.vue'
import mixins from 'vue-typed-mixins'
import AuthorizationMixin from '@/routing/AuthorizationMixin'

export default mixins(AuthorizationMixin).extend({
  components: { Timer, Process },
  props: {
    timer: {
      type: String,
    },
    process: {
      type: String,
    },
    dueTask: {
      type: Boolean,
      default: true,
    },
  },
})
